import user from './module/user/types.js'

export default {
  user
}



// WEBPACK FOOTER //
// ./src/store/types.js